import { render, staticRenderFns } from "./MenuLogo.vue?vue&type=template&id=9cdbeab2&scoped=true"
var script = {}


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9cdbeab2",
  null
  
)

export default component.exports